import { faCube } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Button, Modal, ModalBody } from "reactstrap";
import getDataFromApi from "../getDataFromApi";
import "./Confirm.scss";
import AlertComponent from "../alert/AlertComponent";

function Confirm({ url, close, btnText, method,reload ,images, popup, onDeleteDone, onModelDelete, setDeletingEvalId, onError}) {
  const [confirm, setConfirm] = React.useState(false);
  const [msg, setMsg] = React.useState("");
  const [alert, setAlert] = React.useState();
  const [deleteSucceeded, setDeleteSucceeded] = React.useState(false);
  const [deleteFailed, setDeleteFailed] = React.useState(false);
  const successReportedRef = React.useRef(false);

  // Utility function to transform the message
  const transformMessage = (message) => {
    if (message.includes("Dataset") && message.includes("Version")) {
      // Remove underscores and split into words
      let words = message.replace(/_/g, " ").split(" ");

      // Capitalize the first letter of the second word if it exists
      if (words.length > 1) {
        words[1] = words[1].charAt(0).toUpperCase() + words[1].slice(1);
      }

      return words.join(" ");
    }
    return message;
  };

  const getErrorMessage = (error) => {
    const detail = error?.body?.detail;

    if (typeof detail === "string") return detail;
    if (detail?.message) return detail.message;
    if (error?.body?.message) return error.body.message;

    return error?.message || "Failed to Delete";
  };

  const reportDeleteSuccess = () => {
    if (successReportedRef.current) return;

    successReportedRef.current = true;
    if (onDeleteDone) onDeleteDone(true);
    if (onModelDelete) onModelDelete();
  };

  React.useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const requestUrl = url + confirm;
    setDeleteFailed(false);
    if (!confirm) {
      setDeleteSucceeded(false);
      successReportedRef.current = false;
    }

    getDataFromApi(requestUrl, method ?? "delete",images ?? images)
      .then((r) => {
        const responseMessage =
          typeof r?.detail === "string"
            ? r.detail
            : Array.isArray(r?.detail)
              ? r.detail.join(", ")
              : r?.message || r?.detail?.message || "";

        // console.log(r);
        if (responseMessage) {
          // Transform the message before setting it
          const transformedMsg = transformMessage(responseMessage);
          setMsg(transformedMsg);


          if (confirm && transformedMsg !== "Failed to Delete") {
            setDeleteSucceeded(true);
            reportDeleteSuccess();
            if(popup === "close"){
              setTimeout(() => {
                close();
              }, 1000);
            }
            if (reload) reload();
          } else if(onDeleteDone && !confirm) {
            onDeleteDone(false)
          }
        }

        if (confirm && !responseMessage) {
          setDeleteSucceeded(true);
          reportDeleteSuccess();
          if(popup === "close"){
            setTimeout(() => {
              close();
            }, 1000);
          }
          if (reload) reload();
        }
      })
      .catch((e) => {
        console.log(e);
        const alertPayload = {
          message: getErrorMessage(e),
          status: e?.status === 403 ? "warning" : "error",
        };

        setDeleteFailed(true);
        setDeleteSucceeded(false);
        setDeletingEvalId && setDeletingEvalId(null);
        onDeleteDone && onDeleteDone(false);

        if (onError) {
          onError(alertPayload);
        } else {
          setAlert(alertPayload);
        }

        setConfirm(true);
        setMsg("Failed to Delete");
      });
  }, [confirm, url]);

  return (
    <>
      <AlertComponent alert={alert} />
      <Modal
        size="md"
        scrollable
        fade={false}
        className="confirm-alert-dialog"
        zIndex={30000}
        isOpen={msg?.length > 0}
        toggle={() => {
          setMsg();
          close();
        }}
      >
        <ModalBody className="p-0">
          <div className="p-3">
            <p style={{ color: "var(--text-color)" }}>
              {!confirm && (
                <>
                  <FontAwesomeIcon
                    icon={faCube}
                    color={"#ff0000"}
                    className="me-1"
                  />
                  <b style={{ color: "#ff0000" }}>Warning : </b>
                </>
              )}
              {confirm && String(msg).trim().toLowerCase().startsWith("are you sure you want to delete")
                ? ""
                : msg}
            </p>

            <div className="d-flex justify-content-end">
              <Button
                color={!confirm ? "transparent" : "light"}
                onClick={() => {
                  setDeletingEvalId && setDeletingEvalId(null)
                  if (confirm && deleteSucceeded && !deleteFailed) {
                    reportDeleteSuccess();
                  } else if(onDeleteDone && !confirm) {
                    onDeleteDone(false)
                  }
                  close();
                  // window.location.reload();
                }}
              >
                Close
              </Button>
              {!confirm && !String(msg).includes('Insufficient') && msg !== "You are not Authorized to Delete" && (
                <Button color="danger" onClick={(e) => {setConfirm(true); setDeletingEvalId && setDeletingEvalId(null)}}>
                  {btnText ?? "Delete"}
                </Button>
              )}
            </div>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
}

export default Confirm;
